import React, { useContext, useEffect, useState } from 'react';

import { DiretrizVmpMedsusOffcanvas } from './DiretrizVmpOffcanvas';
import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../components/BoxConteudo';
import CustomButton from '../../../../../components/CustomButton';
import CustomCol from '../../../../../components/CustomCol';
import CustomModal from '../../../../../components/CustomModal';
import CustomOffcanvas from '../../../../../components/CustomOffcanvas';
import CustomRow from '../../../../../components/CustomRow';
import CustomSelectSearchable from '../../../../../components/CustomSelects/CustomSelectSearchable';
import CustomTable from '../../../../../components/CustomTable';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../components/WorkspaceFicha';
import { UserContext } from '../../../../../modules/contexts/Auth/UserProvider';
import { IProdutoVmp } from '../../../../../modules/types/Medsus';
import { getAllMedsusDiretrizVmpByDiretrizId } from '../../../../../services/medsus/medsusDiretrizVmpService';
import { getAllProdutoVmp } from '../../../../../services/medsus/medsusItemService';
import theme from '../../../../../theme';
import { handleSave } from '../../../../../utils/handleSave';
import {
  DiretrizVmpMedsusTableRow,
  headersDiretrizVmpMedsus,
} from '../auxliarProdutoMedsus';
import { INITIAL_FORM_PRODUTO_VMP } from '../utils/initialStates';
import {
  MedsusDiretrizVmp,
  MedsusDiretrizVmpRegistro,
} from '../utils/medsusTypes';

interface DiretrizProps {
  diretrizID: string;
}

type ProdutoOption = {
  value: number;
  label: string;
};

export function DiretrizVmpMedsus(props: DiretrizProps) {
  const { cudProdutoDaf } = useContext(UserContext);
  const [diretrizData, setDiretrizData] = useState<MedsusDiretrizVmpRegistro[]>(
    [],
  );

  // Data Management
  // const fetchData = async () => {
  //   try {
  //     const objetos = await getAllMedsusDiretrizVmpByDiretrizId(
  //       props.diretrizID,
  //     );
  //     setDiretrizData(objetos);
  //   } catch (error) {
  //     console.error('Erro ao obter dados: ', error);
  //   }
  // };

  const fetchData = async (): Promise<MedsusDiretrizVmpRegistro[]> => {
    const objetos = await getAllMedsusDiretrizVmpByDiretrizId(props.diretrizID);
    setDiretrizData(objetos);
    return objetos;
  };

  useEffect(() => {
    fetchData();
  }, [props.diretrizID]);

  const tableData = diretrizData.map((registro) => ({
    id: registro.id,
    vmpObm: registro.vmpObm,
    vmpNome: registro.vmpNome,
    diretrizNome: registro.diretrizNome,
    _row: registro,
  }));

  // Handle Functions

  const handleOpenOffcanvas = () => {
    // setRow(null);
    setShow(true);
  };

  const [show, setShow] = useState(false);
  const [row, setRow] = useState<DiretrizVmpMedsusTableRow | null>(null);

  const onClose = () => setShow(false);
  const handleRowClick = (row: DiretrizVmpMedsusTableRow) => {
    setRow(row);
    setShow(true);
  };

  // Modal Inserir Medicamento
  const [formMain, setFormMain] = useState(INITIAL_FORM_PRODUTO_VMP);
  const [showModalInserir, setShowModalInserir] = useState<boolean>(false);
  const handleShowModalInserir = () => {
    setFormMain(INITIAL_FORM_PRODUTO_VMP());
    setShowModalInserir((state) => !state);
  };

  // Estado para armazenar a lista de produtos e o estado de carregamento
  const [produtosOptions, setProdutosOptions] = useState<ProdutoOption[]>([]);
  const [obmsOptions, setObmsOptions] = useState<ProdutoOption[]>([]);

  useEffect(() => {
    const fetchItemData = async () => {
      try {
        const produtos = await getAllProdutoVmp();

        const produtosFormatados: ProdutoOption[] = [
          { value: 0, label: 'Não informado' },
          ...produtos.map((produto: IProdutoVmp) => {
            return {
              value: produto.id,
              label: produto.nome,
            };
          }),
        ];

        const obmsFormatados: ProdutoOption[] = [
          { value: 0, label: 'Não informado' },
          ...produtos.map((produto: IProdutoVmp) => {
            return {
              value: produto.id,
              label: produto.obm,
            };
          }),
        ];

        setProdutosOptions(produtosFormatados);
        setObmsOptions(obmsFormatados);
      } catch (error) {
        console.error(error);
      }
    };

    fetchItemData(); // Chama a função para buscar os dados
  }, []);

  const handleChangeModal = (e: any) => {
    const { name, value } = e.target;
    const numericValue = Number(value);

    setFormMain((prev) => ({ ...prev, [name]: numericValue }));
  };

  const handleClickModalInserir = async () => {
    salvar();
    handleShowModalInserir();
  };

  const camposObrigatorios: Record<string, string> = {
    produtoVmpId: 'Produto OBM',
    diretrizId: 'ID da Diretriz',
  };

  const camposAjustar = {
    number: ['produtoVmpId', 'diretrizId'],
  };

  const salvar = React.useCallback(async () => {
    const formParaSalvar = {
      ...formMain,
      diretrizId: Number(props.diretrizID),
    };

    setFormMain(formParaSalvar);

    const ok = await handleSave(
      formParaSalvar,
      camposObrigatorios,
      camposAjustar,
      'medsusdiretrizvmp',
      'daf/produtosdaf/medsus',
      undefined,
      false,
      undefined,
    );
    // if (ok) {
    //   fetchData();
    //   handleOpenOffcanvas();
    // }
    if (ok) {
      const novosRegistros = await fetchData();

      const ultimoRegistro = novosRegistros[novosRegistros.length - 1];

      if (ultimoRegistro) {
        setRow({
          id: ultimoRegistro.id,
          vmpObm: ultimoRegistro.vmpObm,
          vmpNome: ultimoRegistro.vmpNome,
          diretrizNome: ultimoRegistro.diretrizNome,
          _row: ultimoRegistro,
        });
        setShow(true);
      }
    }
  }, [formMain, camposObrigatorios, camposAjustar]);

  return (
    <>
      <BoxConteudo boxTitulo={'Medicamentos da Diretriz'}>
        <CustomRow style={{ marginTop: '-15px' }}>
          <CustomTable
            headers={headersDiretrizVmpMedsus}
            data={tableData}
            showPagination={false}
            onRowClick={(row) => handleRowClick(row)}
          />

          <CustomOffcanvas
            title="Detalhamento dos Parâmetros Clínicos do Medicamento na Diretriz"
            show={show}
            onClose={onClose}
            width={'70vw'}
            placement="end"
          >
            <DiretrizVmpMedsusOffcanvas row={row?._row} />
          </CustomOffcanvas>
        </CustomRow>
        {cudProdutoDaf && (
          <CustomRow>
            <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
              <CustomButton
                label={'Novo Medicamento'}
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={handleShowModalInserir}
              />
            </CustomCol>
          </CustomRow>
        )}
      </BoxConteudo>

      {/* Modal Inserir Medicamento */}
      <CustomModal
        icon="medication"
        title="Selecionar Medicamento"
        open={showModalInserir}
        onHide={handleShowModalInserir}
        width="70%"
      >
        <WorkspaceFicha>
          <CustomRow style={{ marginTop: '10px' }}>
            <CustomCol width="300px">
              <CustomSelectSearchable
                name="produtoVmpId"
                options={obmsOptions}
                title="Código OBM"
                value={formMain.produtoVmpId}
                onChange={handleChangeModal}
                required
              />
            </CustomCol>
          </CustomRow>
          <CustomRow>
            <CustomCol>
              <CustomSelectSearchable
                name="produtoVmpId"
                options={produtosOptions}
                title="Medicamento VMP"
                value={formMain.produtoVmpId}
                onChange={handleChangeModal}
                required
              />
            </CustomCol>
          </CustomRow>
          <BarraInferiorBotoes>
            <WorkspaceBotoes inserir onClickInserir={handleClickModalInserir} />
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </CustomModal>
    </>
  );
}
